// extracted by mini-css-extract-plugin
export default {"root":"wB2nQ_H8YCselcXJSuZ8","label":"zz4SGRwDh2K77F7EQGx3"};